import {ActionIcon, createStyles} from '@mantine/core';
import React from 'react';
import {NodeToolbar, Position} from 'reactflow';

import getTestProps from 'test/lib/cypress/getTestProps';
import BenchlingIcon from 'ui-library/icons/BenchlingIcon';

import {useProcedureRunDesignFlowchartNodeActions} from './procedureRunDesignFlowchartNodeActionsContext';

// Gap (px) between the node's top edge and the NodeToolbar. Must be kept in sync with the
// topHoverGutter top / height so the hover bridge covers the gap exactly.
export const NODE_TOOLBAR_OFFSET_PX = 2;

interface ProcedureRunDesignFlowchartNodeToolbarProps {
  isVisible: boolean;
  nodeId: string;
  onToolbarMouseEnter: () => void;
  onToolbarMouseLeave: () => void;
}

export default function ProcedureRunDesignFlowchartNodeToolbar({
  isVisible,
  nodeId,
  onToolbarMouseEnter,
  onToolbarMouseLeave,
}: ProcedureRunDesignFlowchartNodeToolbarProps): JSX.Element {
  const {classes} = useStyles();
  const {onHoverTrashIcon, onUnhoverTrashIcon, onClickTrashIcon} =
    useProcedureRunDesignFlowchartNodeActions();

  return (
    <NodeToolbar
      isVisible={isVisible}
      position={Position.Top}
      offset={NODE_TOOLBAR_OFFSET_PX}
      onMouseEnter={() => {
        onToolbarMouseEnter();
        onHoverTrashIcon(nodeId);
      }}
      onMouseLeave={() => {
        onToolbarMouseLeave();
        onUnhoverTrashIcon();
      }}
      {...getTestProps({component: 'ProcedureRunDesignFlowchartNodeToolbar', element: 'root', key: nodeId})}
      data-amp-safe={false}
    >
      <ActionIcon
        size="xs"
        variant="filled"
        color="dark"
        radius="md"
        aria-label="Remove condition replicate"
        onClick={(event: React.MouseEvent<HTMLButtonElement>) => {
          event.stopPropagation();
          onClickTrashIcon(nodeId);
        }}
        className={classes.trashButton}
        {...getTestProps({component: 'ProcedureRunDesignFlowchartNode', element: 'trashIconButton'})}
      >
        <BenchlingIcon icon="trash-can" className={classes.trashIcon} />
      </ActionIcon>
    </NodeToolbar>
  );
}

const useStyles = createStyles((theme) => ({
  trashButton: {
    '&:hover': {
      backgroundColor: theme.colors.red[8],
    },
  },
  trashIcon: {
    color: theme.white,
  },
}));
